import { render, staticRenderFns } from "./WCardForm.vue?vue&type=template&id=6c5a34fd&scoped=true&"
import script from "./WCardForm.vue?vue&type=script&lang=js&"
export * from "./WCardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5a34fd",
  null
  
)

export default component.exports